package com.devi3east.bashbuddy.purchase.domain.models

import com.devi3east.bashbuddy.features.events.common.data.models.TicketType
import kotlinx.serialization.Serializable

@Serializable
data class PurchasedTicketItem(
    val eventId: String,
    val ticketId: String,
    val ticketType: TicketType,
    val isFiftyFifty: Boolean,
    val serialNumber: String? = null,
    val quantity: Int = 1,
    val unitAmountCents: Long,
    val totalCents: Long,
    val allocations: List<Allocation> = emptyList()
)